import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import {
  Alert,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Snackbar,
  TextField,
} from "@mui/material";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import axios from "axios";
import { useEffect, useContext } from "react";
import AppContext from "../context/AppContext";

function Row(props) {
  const storedUserRole = localStorage.getItem('userRole');

  let subpath = !props.location ? "location" : "gateways";
  const {
    row,
    index,
    setMessage,
    setSeverity,
    setOpenSnack,
    setOpenModal,
    setInputLocation,
    setInputGateway,
    locations,
    setlocations,
    gateways,
    setgateways,
  } = props;
  const [open, setOpen] = React.useState(false);
  const { setLocation, setGateway, userRole } = useContext(AppContext);

  const handleUpdate = async (row) => {
    if (props.location) {
      setInputLocation({
        Name: row.name,
        Description: row.description,
        Address: row.address,
        id: row.id,
      });
    } else {
      setInputGateway({
        location: row.location[0].name,
        description: row.description,
        macAddress: row.mac_address,
        position: row.position,
        id: row.id,
      });
    }
    setOpenModal(true);
  };

  const handleDelete = async (row) => {
    try {
      if (props.location) {
        const response = await axios.post(
          `${process.env.REACT_APP_URL}/api/v1/beacon/delete/location`,
          {
            location_id: row.id,
          }
        );
        if (response.data.status == "success") {
          setMessage(response.data.message);
          setSeverity("success");
          setOpenSnack(true);
          setlocations(true);
        } else {
          setMessage(response.data.message || "Failed to Delete Location");
          setSeverity("error");
          setOpenSnack(true);
        }
      } else {
        const response = await axios.post(
          `${process.env.REACT_APP_URL}/api/v1/beacon/delete/gateway`,
          {
            gateway_id: row.id,
          }
        );
        if (response.data.status == "success") {
          setMessage(response.data.message);
          setSeverity("success");
          setOpenSnack(true);
          setgateways(true);
        } else {
          setMessage(response.data.message || "Failed to Delete Gateway");
          setSeverity("error");
          setOpenSnack(true);
        }
      }
    } catch (err) {
      console.log(err);
      setMessage(err.response.data.error);
      setSeverity("error");
      setOpenSnack(true);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const locationResponse = await axios.get(
          `${process.env.REACT_APP_URL}/api/v1/beacon/get/location`
        );

        if (locationResponse.data.status === "success") {
          setLocation(locationResponse.data.data);
        }
      } catch (error) {
        // Handle error
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [locations]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const gatewayResponse = await axios.get(
          `${process.env.REACT_APP_URL}/api/v1/beacon/get/gateway`
        );
        if (gatewayResponse.data.status === "success") {
          setGateway(gatewayResponse.data.data);
        }
      } catch (error) {
        // Handle error
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [gateways]);

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell align="center" component="th" scope="row">
          {index + 1}
        </TableCell>

        <TableCell align="center" component="th" scope="row">
          {row.name || "NA"}
        </TableCell>
        <TableCell align="center">{row.description || "NA"}</TableCell>
        <TableCell align="center">
          {props.location == "true"
            ? row.address || "NA"
            : row.mac_address || "NA"}
        </TableCell>
        {/* {props.location && (
          <TableCell align="center">
            <Button
              variant="contained"
              style={{ borderRadius: 25, fontSize: 11 }}
              onClick={() => handleUpdate(row)}
            >
              Update
            </Button>
          </TableCell>
        )}
        {props.location && (
          <TableCell align="center">
            <Button
              variant="contained"
              style={{ borderRadius: 25, fontSize: 11 }}
              onClick={() => handleDelete(row)}
            >
              Delete
            </Button>
          </TableCell>
        )} */}
        {!props.location && (
          <TableCell align="center">{row.position || "NA"}</TableCell>
        )}
        {/* {!props.location && (
          <TableCell align="center">{row.supply_voltage || "NA"}</TableCell>
        )}
        {!props.location && (
          <TableCell align="center">{row.battery_voltage || "NA"}</TableCell>
        )}
        {!props.location && (
          <TableCell align="center">{row.gsm_rssi || "NA"}</TableCell>
        )} */}
        {!props.location && (
          <TableCell align="center">{row.created_at || "NA"}</TableCell>
        )}
        <TableCell align="center">
          <Button
            variant="contained"
            style={{ borderRadius: 25, fontSize: 11, backgroundColor: storedUserRole == 'demo' ? 'grey': '' }}
            onClick={() => storedUserRole == 'demo' ? '' : handleUpdate(row)}
          >
            Update
          </Button>
        </TableCell>
        {userRole != "napino" && (
          <TableCell align="center">
            <Button
              variant="contained"
              style={{ borderRadius: 25, fontSize: 11, backgroundColor: storedUserRole == 'demo' ? 'grey': '', cursor: storedUserRole == 'demo' ? 'text': '' }}
              onClick={() =>storedUserRole == 'demo' ? '' : handleDelete(row)}
            >
              Delete
            </Button>
          </TableCell>
        )}
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography
                variant="h6"
                gutterBottom
                component="div"
              ></Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">Id</TableCell>
                    <TableCell align="center">Name</TableCell>
                    <TableCell align="center">Description</TableCell>
                    <TableCell align="center">
                      {!props.location ? "Address" : "Mac Address"}
                    </TableCell>

                    {props.location && (
                      <TableCell align="center">Position</TableCell>
                    )}
                    {props.location && (
                      <TableCell align="center">Created At</TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row[subpath]?.map((historyRow) => (
                    <TableRow key={historyRow.id}>
                      <TableCell align="center" component="th" scope="row">
                        {historyRow.id}
                      </TableCell>
                      <TableCell align="center">
                        {historyRow.name || "NA"}
                      </TableCell>
                      <TableCell align="center">
                        {historyRow.description || "NA"}
                      </TableCell>
                      <TableCell align="center">
                        {props.location == "true"
                          ? historyRow.mac_address || "NA"
                          : historyRow.address || "NA"}
                      </TableCell>
                      {props.location == "true" && (
                        <TableCell align="center">
                          {historyRow.position || "NA"}
                        </TableCell>
                      )}
                      {props.location == "true" && (
                        <TableCell align="center">
                          {historyRow.created_at || "NA"}
                        </TableCell>
                      )}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default function CollapsibleTable(props) {
  const [inputLocation, setInputLocation] = React.useState({
    Name: "",
    Description: "",
    Address: "",
    id: "",
  });
  const [inputGateway, setInputGateway] = React.useState({
    location: "",
    description: "",
    macAddress: "",
    position: "",
    id: "",
  });
  const [gateways, setgateways] = React.useState(false);
  const [locations, setlocations] = React.useState(false);
  const { gateway, location, userRole, loading } = useContext(AppContext);
  const [message, setMessage] = React.useState("");
  const [severity, setSeverity] = React.useState("success");
  const [openSnack, setOpenSnack] = React.useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const [isMobile, setISMobile] = React.useState(window.innerWidth <= 768);

  React.useEffect(()=>{
    const handleResize = ()=> setISMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return ()=> window.removeEventListener("resize", handleResize);
  }, [isMobile]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (props.location) {
      setInputLocation({
        ...inputLocation,
        [name]: value,
      });
    } else {
      setInputGateway({
        ...inputGateway,
        [name]: value,
      });
    }
  };

  const handleSubmit = async () => {
    console.log({ inputLocation });
    try {
      if (props.location) {
        const response = await axios.post(
          `${process.env.REACT_APP_URL}/api/v1/beacon/update/location`,
          {
            location_id: inputLocation.id,
            name: inputLocation.Name,
            description: inputLocation.Description,
            address: inputLocation.Address,
          }
        );
        console.log(290);
        if (response.data.status == "success") {
          setMessage(response.data.message);
          setSeverity("success");
          setOpenSnack(true);
          setlocations(true);
        } else {
          setMessage(response.data.message || "Failed to Update Location");
          setSeverity("error");
          setOpenSnack(true);
        }
      } else {
        const response = await axios.post(
          `${process.env.REACT_APP_URL}/api/v1/beacon/update/gateway`,
          {
            gateway_id: inputGateway.id,
            name: inputGateway.location,
            description: inputGateway.description,
            device_id: inputGateway.macAddress,
            position: inputGateway.position,
          }
        );
        if (response.data.status == "success") {
          setMessage(response.data.message);
          setSeverity("success");
          setOpenSnack(true);
          setgateways(true);
        } else {
          setMessage(response.data.message || "Failed to Update Gateway");
          setSeverity("error");
          setOpenSnack(true);
        }
      }
      setOpenModal(false);
    } catch (err) {
      console.log(err);
      setMessage(err.response.data.error);
      setSeverity("error");
      setOpenSnack(true);
    }
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      {
        loading ? (
                      <TableContainer component={Paper}>
          <Table aria-label="collapsible table">
            <TableHead>
              <TableRow>
                <TableCell align="center">
                  <strong style={{ color: "rgb(28, 70, 146)" }}>S.No</strong>
                </TableCell>
  
                {props.location && (
                  <TableCell align="center">
                  <strong style={{ color: "rgb(28, 70, 146)" }}>Name</strong>
                </TableCell>
                )}
                {!props.location && (
                  <TableCell align="center">
                  <strong style={{ color: "rgb(28, 70, 146)" }}>Location</strong>
                </TableCell>
                )}
                <TableCell align="center">
                  <strong style={{ color: "rgb(28, 70, 146)" }}>
                    Descriptions
                  </strong>
                </TableCell>
                <TableCell align="center">
                  <strong style={{ color: "rgb(28, 70, 146)" }}>
                    {props.location ? "Address" : "Imei No"}
                  </strong>
                </TableCell>
                {!props.location && (
                  <TableCell align="center">
                    <strong style={{ color: "rgb(28, 70, 146)" }}>
                      POSITION
                    </strong>
                  </TableCell>
                )}
                {/* {!props.location && (
                  <TableCell align="center">
                    <strong style={{ color: "rgb(28, 70, 146)" }}>
                      Supply Voltage
                    </strong>
                  </TableCell>
                )}
                {!props.location && (
                  <TableCell align="center">
                    <strong style={{ color: "rgb(28, 70, 146)" }}>
                      Battery Voltage
                    </strong>
                  </TableCell>
                )}
                {!props.location && (
                  <TableCell align="center">
                    <strong style={{ color: "rgb(28, 70, 146)" }}>
                      Gsm Rssi
                    </strong>
                  </TableCell>
                )} */}
                {!props.location && (
                  <TableCell align="center">
                    <strong style={{ color: "rgb(28, 70, 146)" }}>
                      Created At
                    </strong>
                  </TableCell>
                )}
                <TableCell />
              </TableRow>
            </TableHead>
             <TableBody >
             <TableRow>
             <TableCell align="center">
                </TableCell>
             <TableCell align="center">
                </TableCell>

             {
                    !props.location && <TableCell align="center">
                </TableCell>
             }

          <Box display="flex" justifyContent="center" alignItems="center" height="10vh">
              
             <CircularProgress size={28}/> 
          </Box>

             </TableRow>

            
                 
             </TableBody>
          </Table>
        </TableContainer>
        ) : (
         <>
          <TableContainer component={Paper}>
          <Table aria-label="collapsible table">
            <TableHead>
              <TableRow>
                <TableCell align="center">
                  <strong style={{ color: "rgb(28, 70, 146)" }}>S.No</strong>
                </TableCell>
  
                {props.location && (
                  <TableCell align="center">
                  <strong style={{ color: "rgb(28, 70, 146)" }}>Name</strong>
                </TableCell>
                )}
                {!props.location && (
                  <TableCell align="center">
                  <strong style={{ color: "rgb(28, 70, 146)" }}>Location</strong>
                </TableCell>
                )}
                <TableCell align="center">
                  <strong style={{ color: "rgb(28, 70, 146)" }}>
                    Descriptions
                  </strong>
                </TableCell>
                <TableCell align="center">
                  <strong style={{ color: "rgb(28, 70, 146)" }}>
                    {props.location ? "Address" : "Imei No"}
                  </strong>
                </TableCell>
                {!props.location && (
                  <TableCell align="center">
                    <strong style={{ color: "rgb(28, 70, 146)" }}>
                      POSITION
                    </strong>
                  </TableCell>
                )}
                {/* {!props.location && (
                  <TableCell align="center">
                    <strong style={{ color: "rgb(28, 70, 146)" }}>
                      Supply Voltage
                    </strong>
                  </TableCell>
                )}
                {!props.location && (
                  <TableCell align="center">
                    <strong style={{ color: "rgb(28, 70, 146)" }}>
                      Battery Voltage
                    </strong>
                  </TableCell>
                )}
                {!props.location && (
                  <TableCell align="center">
                    <strong style={{ color: "rgb(28, 70, 146)" }}>
                      Gsm Rssi
                    </strong>
                  </TableCell>
                )} */}
                {!props.location && (
                  <TableCell align="center">
                    <strong style={{ color: "rgb(28, 70, 146)" }}>
                      Created At
                    </strong>
                  </TableCell>
                )}
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {props.location
                ? location?.map((row, index) => (
                    <Row
                      key={row.id}
                      row={row}
                      index={index}
                      location={props.location}
                      setMessage={setMessage}
                      setSeverity={setSeverity}
                      setOpenSnack={setOpenSnack}
                      setOpenModal={setOpenModal}
                      setInputLocation={setInputLocation}
                      setInputGateway={setInputGateway}
                      setgateways={setgateways}
                      gateways={gateways}
                      setlocations={setlocations}
                      locations={locations}
                    />
                  ))
                : gateway?.map((row, index) => (
                    <Row
                      key={row.id}
                      row={row}
                      index={index}
                      location={props.location}
                      setMessage={setMessage}
                      setSeverity={setSeverity}
                      setOpenSnack={setOpenSnack}
                      setOpenModal={setOpenModal}
                      setInputLocation={setInputLocation}
                      setInputGateway={setInputGateway}
                      gateways={gateways}
                      setlocations={setlocations}
                      locations={locations}
                    />
                  ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Modal
          open={openModal}
          onClose={handleCloseModal}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
  
              width:isMobile ? 300 : 600,
              maxHeight: "100%",
  
              overflowY: "auto",
              overflowX: "auto",
              backgroundColor: "white",
              boxShadow: 24,
              padding: "20px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                justifyContent: "flex-end",
                cursor: "pointer",
              }}
              onClick={handleCloseModal}
            >
              <img style={{ width: 20, height: 20 }} src="/Close.png" />
            </div>
            {props.location ? (
              <form style={{ flexDirection: "column", display: "flex" }}>
                <TextField
                  label="Name"
                  name="Name"
                  value={inputLocation.Name}
                  onChange={(e) => handleInputChange(e)}
                  margin="normal"
                  required
                />
                <TextField
                  label="Description"
                  name="Description"
                  value={inputLocation.Description}
                  onChange={(e) => handleInputChange(e)}
                  margin="normal"
                />
                <TextField
                  label="Address"
                  name="Address"
                  value={inputLocation.Address}
                  onChange={(e) => handleInputChange(e)}
                  margin="normal"
                  required
                />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                >
                  Update
                </Button>
              </form>
            ) : (
              <form style={{ flexDirection: "column", display: "flex" }}>
                <FormControl margin="normal">
                  <InputLabel id="asset-select-label">Location</InputLabel>
                  <Select
                    labelId="asset-select-label"
                    id="asset-select"
                    name="location"
                    value={inputGateway.location}
                    onChange={(e) => handleInputChange(e)}
                    label="Select Location"
                  >
                    {location?.map((asset) => (
                      <MenuItem key={asset.id} value={asset.name}>
                        {" "}
                        {asset.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
  
                <TextField
                  label="Description"
                  name="description"
                  value={inputGateway.description}
                  onChange={(e) => handleInputChange(e)}
                  margin="normal"
                />
                <TextField
                  label="Position"
                  name="position"
                  value={inputGateway.position}
                  onChange={(e) => handleInputChange(e)}
                  margin="normal"
                  required
                />
                <TextField
                  label="Device Id"
                  name="macAddress"
                  value={inputGateway.macAddress}
                  onChange={(e) => handleInputChange(e)}
                  margin="normal"
                  required
                />
  
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                >
                  Update
                </Button>
              </form>
            )}
          </div>
        </Modal>
        <Snackbar open={openSnack} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity={severity}>
            {message}
          </Alert>
        </Snackbar>
             </>
        )
      }

    </>
  );
}
